// @ts-nocheck

class CompareDevices {
	constructor() {
		this.cardSelector = '.js-compare-card';
		this.swatchSelector = '.product__swatch';
		this.imageSelector = '.compare__card-img';
		this.buyButtonSelector = '.js-add-to-cart';
		this.activeSwatchClass = 'product__swatch--active';
		this.activeImageClass = ['is-active', 'js-fly-image'];
		this.buyLabelClass = 'compare__buy-label';
		this.variantIdAttr = 'data-id';
		this.availableAttr = 'data-available';
		this.priceAttr = 'data-price';
		this.buttonVariantIdAttr = 'data-variant-id';
	}

	isUkLocale() {
		const locale = window.Shopify?.locale || document.documentElement.lang || '';
		return locale.toLowerCase() === 'uk';
	}

	getBuyLabel(price) {
		const prefix = this.isUkLocale() ? 'Купити за' : 'Купить за';
		return `${prefix} ${price}`;
	}

	getUnavailableLabel() {
		return this.isUkLocale() ? 'немає в наявності' : 'нет в наличии';
	}

	getOrCreateBuyLabel(button) {
		const existing = button.querySelector(`.${this.buyLabelClass}`);
		if (existing) {
			return existing;
		}

		const label = document.createElement('span');
		label.className = this.buyLabelClass;

		Array.from(button.childNodes).forEach((node) => {
			if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
				node.textContent = '';
			}
		});

		const loader = button.querySelector('.btn__loader');
		if (loader) {
			button.insertBefore(label, loader);
		} else {
			button.append(label);
		}

		return label;
	}

	setActiveState(collection, activeClass, activeIndex) {
		const classes = Array.isArray(activeClass) ? activeClass : [activeClass];

		collection.forEach((item, index) => {
			classes.forEach((className) => {
				item.classList.toggle(className, index === activeIndex);
			});
		});
	}

	updateBuyButton(card, swatch) {
		const buyButton = card.querySelector(this.buyButtonSelector);
		if (!buyButton || !swatch) {
			return;
		}

		const variantId = swatch.getAttribute(this.variantIdAttr) || '';
		const isAvailable = swatch.getAttribute(this.availableAttr) === 'true';
		const price = swatch.getAttribute(this.priceAttr) || '';

		if (variantId) {
			buyButton.setAttribute(this.buttonVariantIdAttr, variantId);
		} else {
			buyButton.removeAttribute(this.buttonVariantIdAttr);
		}

		const label = this.getOrCreateBuyLabel(buyButton);
		if (isAvailable) {
			label.textContent = this.getBuyLabel(price);
		} else {
			label.textContent = this.getUnavailableLabel();
		}

		buyButton.classList.toggle('btn--disabled', !isAvailable);
		if (isAvailable) {
			buyButton.removeAttribute('disabled');
		} else {
			buyButton.setAttribute('disabled', 'disabled');
		}
	}

	updateCard(card, index) {
		const swatches = Array.from(card.querySelectorAll(this.swatchSelector));
		const images = Array.from(card.querySelectorAll(this.imageSelector));
		if (!swatches.length) {
			return;
		}

		const safeIndex = Math.max(0, Math.min(index, swatches.length - 1));
		const activeSwatch = swatches[safeIndex];

		this.setActiveState(swatches, this.activeSwatchClass, safeIndex);
		this.setActiveState(images, this.activeImageClass, safeIndex);
		this.updateBuyButton(card, activeSwatch);
	}

	initCard(card) {
		const swatches = Array.from(card.querySelectorAll(this.swatchSelector));
		if (!swatches.length) {
			return;
		}

		swatches.forEach((swatch, index) => {
			swatch.addEventListener('click', () => {
				this.updateCard(card, index);
			});
		});

		const initialIndex = swatches.findIndex((swatch) => swatch.classList.contains(this.activeSwatchClass));
		this.updateCard(card, initialIndex >= 0 ? initialIndex : 0);
	}

	initSticky() {
		const row = document.querySelector('.compare__row--heading');
		const title = row?.querySelector('.compare__card-title');
		const header = document.querySelector('.header');
		if (!title) {
			return;
		}

		let stickyTop = 0;

		const toggleStuck = () => {
			row.classList.toggle('is-stuck', row.getBoundingClientRect().top <= stickyTop + 1);
		};

		const update = () => {
			const offset = title.getBoundingClientRect().top - row.getBoundingClientRect().top;
			const headerHeight = header?.offsetHeight || 0;
			stickyTop = headerHeight - offset + 16;
			row.style.setProperty('--compare-sticky-top', `${stickyTop}px`);
			toggleStuck();
		};

		update();
		window.addEventListener('scroll', toggleStuck, { passive: true });
		new ResizeObserver(update).observe(row);
		if (header) {
			new ResizeObserver(update).observe(header);
		}
	}

	init() {
		const cards = Array.from(document.querySelectorAll(this.cardSelector));
		if (!cards.length) {
			return;
		}

		cards.forEach((card) => {
			this.initCard(card);
		});

		this.initSticky();
	}
}

new CompareDevices().init();